import _ from "lodash";

export const isUserInEventAudience = (
	user,
	audienceType,
	audienceTypeSelection,
) => {
	if (!audienceType || audienceType === "All") return true;

	switch (audienceType) {
		case "Custom":
			if (_.isEmpty(audienceTypeSelection)) return true;
			return _.some(audienceTypeSelection, (audience) =>
				isUserInEventAudience(
					user,
					audience.AudienceType,
					audience.AudienceTypeSelection,
				),
			);
		case "Category":
			return (
				_.isEmpty(audienceTypeSelection) ||
				user.category === audienceTypeSelection
			);
		case "UserType":
			return (
				_.isEmpty(audienceTypeSelection) || user.type === audienceTypeSelection
			);
		case "UserTags": {
			if (_.isEmpty(audienceTypeSelection)) return true;
			if (_.isEmpty(user.tags)) return false;

			const selectedTags = Array.isArray(audienceTypeSelection)
				? audienceTypeSelection
				: [audienceTypeSelection];
			return _.some(user.tags, (tag) => {
				if (!tag) return false;
				return _.some(selectedTags, (selectedTag) => {
					return (
						tag === selectedTag ||
						tag.Id === selectedTag ||
						tag.TagId === selectedTag ||
						tag.Title === selectedTag
					);
				});
			});
		}
		default:
			return true;
	}
};

export const getAttendeeSearchContacts = ({
	users = [],
	attendeeSearch = "",
	attendees = [],
	audienceType,
	audienceTypeSelection,
}) => {
	const normalizedSearch = attendeeSearch.toLowerCase();

	return _.orderBy(
		_.filter(users, (user) => {
			const displayName = user.displayName || "";
			return (
				!user.Deleted &&
				(!normalizedSearch ||
					displayName.toLowerCase().indexOf(normalizedSearch) > -1) &&
				isUserInEventAudience(user, audienceType, audienceTypeSelection) &&
				attendees.findIndex(
					(attendee) => (attendee.id || attendee.Id) === user.Id,
				) < 0
			);
		}),
		"displayName",
	);
};
